import React from 'react'

import { DisplayResultProps } from './excel-drop-area.types'

const DisplayResult = ({ result }: DisplayResultProps) => {
  return (
    result &&
    result.isError && (
      <div className={result.isError ? 'excelErrorTable' : 'excelMessageArea'} id='header'>
        <p>{result.message}</p>
      </div>
    )
  )
}

export default DisplayResult
